<div class="home-container">
  @if (hasAdminPermission) {
  <div class="admin-section">
    <button class="admin-btn" (click)="goToEmployeeInterface()">
      <span class="admin-icon"
        ><lucide-icon name="settings" [size]="16"></lucide-icon
      ></span>
      <span class="admin-text">Employee Interface</span>
    </button>
  </div>
  }

  <div class="booking-section">
    <app-book-a-court></app-book-a-court>
  </div>
</div>
